function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  d: "M12.874 12.826c-.986-.537-1.412 1.089-2.225.272-.04-.038-.075-.068-.106-.09-1.019-.993-1.894-2.111-2.61-3.326-.694-1.226-1.225-2.544-1.575-3.923-.005-.04-.012-.083-.025-.136-.3-1.11 1.322-.666 1.348-1.792.017-.649.052-1.944.065-2.613C7.762.263 6.555.12 5.772.033c-.783-.087-2.38-.102-2.403 1.272-.084 3.444.77 6.753 2.4 9.627 1.674 2.849 4.11 5.24 7.137 6.891 1.201.668 1.986-.723 2.303-1.444.316-.722.796-1.84-.04-2.302-.586-.326-1.727-.94-2.295-1.25z"
});

var SvgHandset = function SvgHandset(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHandset, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/handset.cba80c96.svg";
export { ForwardRef as ReactComponent };